"use client"
import React, { useState } from 'react';
import ConfirmationModal from '../../components/modals/confirmationModal';
import SendMessageModal from '../../components/modals/SendMessageModal';
import Senticon from '../../assets/icons/sent-msg.svg'
import usersIcon from "../../assets/icons/usersIcon.svg"
import documentIcon from "../../assets/icons/documentIcon.svg"
import StatCard from "../../components/shared/StatCard"
import AuditLogsTable from '../../components/shared/AuditLogsTable';
import UserQueriesTable from '../../components/shared/UserQueriesTable';


export default function SubAdminDashboard() {

    const auditLogs = [
        {
            activity: 'Logged in',
            comment: 'Logged into the sub-admin',
            email: 'majidali@nesl-it.com',
            datetime: '01 July, 2025 - 14:30'
        },
        {
            activity: 'Resolve query',
            comment: 'Resolved query #0981',
            email: 'muhammadhaseeb@nesl-it.com',
            datetime: '04 July, 2025 - 09:23'
        }
    ];

    const [userQueries, setUserQueries] = useState([
        {
            query_id: '#0001',
            email: 'majidali@nesl-it.com',
            message: 'Need help with my pro accout',
            status: 'SOLVED',
            solution: 'Resolved earlier.'
        },
        {
            query_id: '#0002',
            email: 'muhammadhaseeb@nesl-it.com',
            message: 'Need help with my pro accout',
            status: 'PENDING'
        },
        {
            query_id: '#0003',
            email: 'muhammadhaseeb@nesl-it.com',
            message: 'Need help with my pro accout',
            status: 'PENDING'
        },
        {
            query_id: '#0004',
            email: 'muhammadhaseeb@nesl-it.com',
            message: 'Need help with my pro accout',
            status: 'SOLVED',
            solution: 'Reinstalled app.'
        },
        {
            query_id: '#0005',
            email: 'muhammadhaseeb@nesl-it.com',
            message: 'Need help with my pro accout',
            status: 'SOLVED',
            solution: 'Billing updated.'
        },
        {
            query_id: '#0006',
            email: 'muhammadhaseeb@nesl-it.com',
            message: 'Need help with my pro accout',
            status: 'SOLVED',
            solution: 'Workspace role fixed.'
        },
        {
            query_id: '#0007',
            email: 'muhammadhaseeb@nesl-it.com',
            message: 'Need help with my pro accout',
            status: 'PENDING'
        },
        {
            query_id: '#0008',
            email: 'muhammadhaseeb@nesl-it.com',
            message: 'How can I export my document with pro account...',
            status: 'PENDING'
        }
    ]);

    // Send flow state
    const [selectedQuery, setSelectedQuery] = useState(null);
    const [sendModalOpen, setSendModalOpen] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [draftSolution, setDraftSolution] = useState('');



    const handleViewDetails = (query) => {
        setSelectedQuery(query);
        setDraftSolution(query.solution || '');
        setSendModalOpen(true);
    };         
    	// 1) Close compose modal, 2) open confirmation
	const handleSendMessage = (solutionText) => {
		setDraftSolution(solutionText);
		setSendModalOpen(false); // close first modal
		setConfirmOpen(true); // open "Message sent" modal
	};

	// Confirm -> mark as solved, close confirm; DO NOT open a third modal automatically
	const handleMarkAsSolved = () => {
		if (!selectedQuery) return;
		setUserQueries((prev) =>
			prev.map((q) =>
				q.query_id === selectedQuery.query_id
					? { ...q, status: 'SOLVED', solution: draftSolution }
					: q
			)
		);
		setConfirmOpen(false);
	};                                     



  return (
    <div className="">
      {/* Header Section */}
        <div className="flex flex-col items-center md:flex-row md:justify-between md:items-center gap-4 mb-10 md:mb-[50px]">

        <h1 className="text-2xl sm:text-3xl font-semibold text-dark-blue text-center md:text-left">
            Welcome, Carlotta
        </h1>
        </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 sm:gap-6 mb-10 md:mb-[50px]">
        <StatCard 
          icon={usersIcon}
          bgColor="bg-lightGrey"
          textColor="text-dark-blue"
          label="Total register users"
          value="28,891"
          newValue="5,541"
        />
        <StatCard 
          icon={documentIcon}
          bgColor="bg-lightGrey"
          textColor="text-purple-600"
          label="Total projects"
          value="41,900"
          newValue="14,543"
        />
      </div>

        <AuditLogsTable heading={"Your audit logs"} auditLogs={auditLogs} />

        <div className="flex justify-between flex-col md:flex-row items-center mb-12">
            <div>
                <h1 className="text-[22px] font-medium text-dark-blue">
                    Recent users queries
                </h1>
            </div>

            <div>
            <a
                href="user-queries"
                className="inline-flex items-center gap-2 text-dark-blue text-20 underline leading-24"
            >
                View all
            </a>
            </div>
        </div>
        <UserQueriesTable 
        userQueries={userQueries.slice(0, 2)} 
        onViewDetails={handleViewDetails} 
        />	
		<SendMessageModal
				isOpen={sendModalOpen}
				onClose={() => setSendModalOpen(false)}
				isImported={false}
				query={selectedQuery}
				onSend={handleSendMessage}
			/>

			{/* Message sent confirmation */}
			<ConfirmationModal
				isOpen={confirmOpen}
				onClose={() => setConfirmOpen(false)}
                icon={<img src={ Senticon} alt="Sent" className="mx-auto" />}
				heading="Message sent"
				description="Your solution message sent to user successfully."
				primaryButtonText="Mark as solved"
				secondaryButtonText="Cancel"
				onPrimaryClick={handleMarkAsSolved}
				onSecondaryClick={() => setConfirmOpen(false)}
			/>
    </div>
  )
}
